/**
 * Отзывы покупателей об аптеках: `GET /admin/reviews` — только роль
 * «Супер-админ». Ручки на бэкенде ещё нет: по просьбе заказчика раздел
 * работает на mock со стартовым набором (`@dorixona/api/reviews`), за флагом
 * `VITE_FEATURE_REVIEWS`; источник выбирает `VITE_REVIEWS_MOCK`.
 */
import { useMemo } from 'react'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import {
  createHttpAdminReviews,
  createMockAdminReviews,
  type AdminReviewsBackend,
  type AdminReviewsQuery,
} from '@dorixona/api/reviews'
import { useApi } from '../../api/context'
import { keys } from '../../api/keys'
import { env } from '../../config/env'

export function useReviewsBackend(): AdminReviewsBackend {
  const api = useApi()
  return useMemo(
    () =>
      env.reviewsMock
        ? createMockAdminReviews({ storage: window.localStorage })
        : createHttpAdminReviews(api),
    [api],
  )
}

export function useReviews(query: AdminReviewsQuery) {
  const backend = useReviewsBackend()
  return useQuery({
    queryKey: keys.reviews({ ...query }),
    queryFn: () => backend.list(query),
    placeholderData: keepPreviousData,
  })
}
